import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import About from './pages/About';
import UpcomingProjects from './pages/Projects/UpcomingProjects'; 
import CompletedProjects from './pages/Projects/CompletedProjects'; 
import OpenPlots from './pages/Projects/OpenPlots';
import ResidentialVentures from './pages/Projects/ResidentialVentures';
import PlotSales from './pages/Services/PlotSales';
import VentureDevelopment from './pages/Services/VentureDevelopment';
import EndToEndSolutions from './pages/Services/EndToEndSolutions';
import Gallery from './pages/Gallery';
import Contact from './pages/Contact';
import WhatsApp from './pages/WhatsApp';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="projects/UpcomingProjects" element={<UpcomingProjects />} />
          <Route path="projects/CompletedProjects" element={<CompletedProjects />} />
          <Route path="projects/open-plots" element={<OpenPlots />} />
          <Route path="projects/residential-ventures" element={<ResidentialVentures />} />
          <Route path="services/plot-sales" element={<PlotSales />} />
          <Route path="services/venture-development" element={<VentureDevelopment />} />
          <Route path="services/end-to-end-solutions" element={<EndToEndSolutions />} />
          <Route path="gallery" element={<Gallery />} />
          <Route path="contact" element={<Contact />} />
          <Route path="WhatsApp" element={<WhatsApp />} />

        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;